/**
 * Jayone — Hero slideshow click → /pages/products
 *
 * Catalog mode hero has no overlay text/CTA. The whole hero acts as a
 * single click target that routes to the full product catalog.
 *
 * Implementation: event delegation on the document so it survives the
 * slideshow component re-rendering on resize / slide-change.
 *
 * Safe-guards:
 *   - Ignore clicks on prev/next arrows + dots (their own UI controls)
 *   - Ignore clicks on real <a> or <button> children (future-proof if
 *     we add an overlay CTA later)
 *   - Modifier-key clicks open in a new tab (Ctrl/Cmd, middle-click)
 */
(function () {
  'use strict';

  // Fallback only. Each slide's own link (.slide__link, set per campaign in index.json)
  // wins, so a seasonal hero lands on its campaign page instead of the catalog.
  var FALLBACK_URL = '/pages/products';

  function targetFor(slideItem) {
    var link = slideItem.querySelector('a.slide__link[href]');
    return (link && link.getAttribute('href')) || FALLBACK_URL;
  }

  function isControlClick(target) {
    // Flickity carousel controls
    if (target.closest('.flickity-prev-next-button')) return true;
    if (target.closest('.flickity-page-dots')) return true;
    // Real anchors / buttons inside the slide
    if (target.closest('a')) return true;
    if (target.closest('button')) return true;
    return false;
  }

  document.addEventListener('click', function (event) {
    var slideItem = event.target.closest('slideshow-component .item');
    if (!slideItem) return;
    if (isControlClick(event.target)) return;

    // Honor open-in-new-tab modifiers
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
      window.open(targetFor(slideItem), '_blank');
      return;
    }

    window.location.href = targetFor(slideItem);
  });
})();
